<template>
  <div>
    <section class="section">
      <v-container grid-list-lg>
        <h1 style="text-align:center; font-size:50px; line-height:1.1em;">
          <!-- <span style="font-size:70px;">Portal</span> -->
          Portal
          <br>
          <img src="/images/logo-nome-simples.svg" style="height:90px;">
        </h1>
        <br>
        <v-layout justify-center row wrap>
          <v-flex sm4 v-for="(o, i) in items" :key="i" class="botao">
            <v-btn
              depressed
              color="blue"
              dark
              large
              block
              :href="o.url"
              style="padding-top:60px;padding-bottom:60px;"
            >
              <v-icon>{{o.icon}}</v-icon>
              <span>{{o.name}}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        name: "Alunos",
        icon: "face",
        url: "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=ALUNO"
      },
      {
        name: "Pais e Responsáveis",
        icon: "wc",
        url:
          "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=RESPONSAVEL"
      },
      {
        name: "Professores",
        icon: "person",
        url:
          "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=PROFESSOR"
      },
      {
        name: "Coordenadores",
        icon: "folder_shared",
        url:
          "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=COORDENADOR"
      },
      {
        name: "Colaboradores",
        icon: "group",
        url:
          "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=COLABORADOR"
      },
      {
        name: "Consulta à Biblioteca",
        icon: "local_library",
        url: "https://webserver.ciaporte.com.br/Engenho/bbpesquisa.xhtml"
      },
      {
        name: "Autencidade de Documentos",
        icon: "assignment_turned_in",
        url: "https://webserver.ciaporte.com.br/Engenho/autenticidade.xhtml"
      }
    ]
  }),
  components: {}
};
</script>

<style lang="scss">
.botao {
  .v-btn {
    .v-icon {
      display: block;
      font-size: 3em;
    }
    .span {
      display: block;
    }
  }
}
p {
  text-align: center;
  font-weight: bold;
}
</style>
